<template>
  <div>
    <DisplayContentWorkspaces v-if="field.viewTypeCustom === 'DisplayContentWorkspaces'" v-model="newValue" />

    <RenderingContentAlgoliaSearch v-if="field.viewTypeCustom === 'RenderingContentAlgoliaSearch'" v-model="newValue" :label="field.label" />

    <RuleContexts v-if="field.viewTypeCustom === 'RuleContexts'" v-model="newValue" />

    <RuleConditions v-if="field.viewTypeCustom === 'RuleConditions'" v-model="newValue" :workspaces="formContent.workspaces" :in-create-mode="!formContent.uuid" />

    <RuleActions v-if="field.viewTypeCustom === 'RuleActions'" v-model="newValue" :workspaces="formContent.workspaces" :conditions="formContent.conditions" :actions-modules-configuration="field.actionsModulesConfiguration" :custom-actions-options="field.customActionsOptions" />

    <SiteWorkspace v-if="field.viewTypeCustom === 'SiteWorkspace'" v-model="newValue" />

    <MenuPositionByType v-if="field.viewTypeCustom === 'MenuPositionByType' && merchType" v-model="newValue" :merch-type="merchType" />

    <ReferenceConfiguration v-if="field.viewTypeCustom === 'ReferenceConfiguration'" :workspace="formContent.displayWorkspace || formContent.siteWorkspace" :reference-configuration="formContent.referenceConfiguration" />

    <PriceTab
      v-if="field.viewTypeCustom === 'PriceTab'"
      v-model="newValue"
      :field="field"
      :form-content="formContent"
    />

    <HoranetTariffs
      v-if="field.viewTypeCustom === 'HoranetTariffs'"
      v-model="newValue"
      :horanet-product="formContent.horanetProduct"
      :raw-field="rawContentTypes"
      :field="field"
      :raw-content-types="rawContentTypes"
    />

    <CSVTable
      v-if="field.viewTypeCustom === 'CSVTable'"
      v-model="newValue"
      :field="field"
      :status="formContent.status"
    />

    <SendEmailButton
      v-if="field.viewTypeCustom === 'SendEmailButton'"
      v-model="newValue"
      :field="field"
      :uuid="formContent.uuid"
      :form-content="formContent"
    />

    <EndPromotionalCampaignButton
      v-if="field.viewTypeCustom === 'EndPromotionalCampaignButton'"
      v-model="newValue"
      :field="field"
      :form-content="formContent"
    />

    <LLMTags
      v-if="field.viewTypeCustom === 'LLMTags'"
      v-model="newValue"
      :field="field"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, defineEmits, defineProps } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import RuleConditions from './Customs/RuleConditions.vue';
import RuleActions from './Customs/RuleActions.vue';
import RuleContexts from './Customs/RuleContexts.vue';
import SiteWorkspace from './Customs/SiteWorkspace.vue';
import MenuPositionByType from './Customs/MenuPositionByType.vue';
import DisplayContentWorkspaces from './Customs/DisplayContentWorkspaces.vue';
import RenderingContentAlgoliaSearch from './Customs/RenderingContentAlgoliaSearch.vue';
import ReferenceConfiguration from './Customs/ReferenceConfiguration.vue';
import HoranetTariffs from './Customs/HoranetTariffs.vue';
import CSVTable from './Customs/CSVTable.vue';
import SendEmailButton from './Customs/SendEmailButton.vue';
import EndPromotionalCampaignButton from './Customs/EndPromotionalCampaignButton.vue';
import PriceTab from './Customs/PriceTab.vue';
import LLMTags from './Customs/LLMTags.vue';

const emit = defineEmits(['input']);

const props = defineProps({
  value: { type: [Array, Boolean, Number, String, Object], default: null },
  workspaces: { type: Array, default: null },
  field: { type: Object, default: null },
  formContent: { type: Object, default: null },
  rawContentTypes: { type: Object, default: null }
});

const newValue = ref(props.value);
const store = useStore();

const currentEnvironment = process.env.VUE_APP_ENV;

const merchType = computed(() => {
  if (props.formContent && props.formContent.siteWorkspace && props.formContent.siteWorkspace.length) {
    const workspace = store.state.workspaces.find(w => props.formContent.siteWorkspace[0] === w.code);

    return workspace?.settings?.merch?.type ? workspace.settings.merch.type : 'ucpa';
  }
  return null;
});

watch(newValue, val => {
  emit('input', val || null);
}, { deep: true });

</script>

<style></style>
